import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileSdk"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 6.75H20.925L18 11.7V6.75H16.5V17.25H18V14.025L18.675 12.9L20.925 17.25H22.5L19.575 11.55L22.5 6.75ZM12 17.25H9V6.75H12C13.6548 6.75494 14.9951 8.0952 15 9.75V14.25C14.9951 15.9048 13.6548 17.2451 12 17.25ZM10.5 15.75H12C12.8274 15.7475 13.4975 15.0774 13.5 14.25V9.75C13.4975 8.9226 12.8274 8.25247 12 8.25H10.5V15.75ZM6 17.25H1.5V15.75H6V12.75H3C2.1726 12.7475 1.50247 12.0774 1.5 11.25V8.25C1.50247 7.4226 2.1726 6.75247 3 6.75H7.5V8.25H3V11.25H6C6.8274 11.2525 7.49753 11.9226 7.5 12.75V15.75C7.49753 16.5774 6.8274 17.2475 6 17.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileSdk.vue"]]);
